import React, { useEffect, useState } from 'react';

import { OrderService } from '../../services/order.service';
import { OrderStatus } from '../../constants/order-status.constants';
import { toast } from 'react-toastify';

const AdminDashboard = () => {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [selectedOrder, setSelectedOrder] = useState(null);

  useEffect(() => {
    console.log('1');
    fetchOrders(false);
  }, []);

  const fetchOrders = async (isUpdate = false) => {
    setLoading(true);
    try {
      const fetchedOrders = await OrderService.fetchOrders();
      toast.success(isUpdate ? 'Updated Status' : 'Fetched latest orders');
      setOrders(fetchedOrders);
      setLoading(false);
    } catch (error) {
      toast.error('Error fetching orders');
      setLoading(false);
    }
  };

  const updateOrderStatus = async (orderId, status) => {
    setLoading(true);
    try {
      await OrderService.updateOrderStatus(orderId, status);
      fetchOrders(true);
      setShowModal(false);
    } catch (error) {
      toast.error('Error updating order status');
      setLoading(false);
    }
  };

  const openModal = (order) => {
    setSelectedOrder(order);
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
    setSelectedOrder(null);
  };

  return (
    <div style={styles.container}>
      <h2>Admin Dashboard</h2>

      <div style={styles.buttons}>
        <button onClick={() => fetchOrders(false)} style={styles.button}>
          Fetch Orders
        </button>
      </div>

      {loading && <p>Loading orders...</p>}

      <div style={{ overflowX: 'auto', marginTop: '50px' }}>
        <table style={styles.table}>
          <thead style={{ borderBottom: '2px solid black' }}>
            <tr>
              <th className='table-column'>Order ID</th>
              <th className='table-column'>Name</th>
              <th className='table-column'>Email</th>
              <th className='table-column'>Phone Number</th>
              <th className='table-column'>Address</th>
              <th className='table-column'>Order Items</th>
              <th className='table-column'>Total</th>
              <th className='table-column'>Status</th>
              <th className='table-column'>Actions</th>
            </tr>
          </thead>
          <tbody>
            {orders.map((order) => (
              <>
                {/* Main Row */}
                <tr
                  style={{
                    textAlign: 'center',
                    borderBottom: '5px solid black',
                  }}
                  key={order.orderId}
                >
                  <td>{order.orderId}</td>
                  <td>{order.name}</td>
                  <td>{order.email}</td>
                  <td>{order.phone}</td>
                  <td>
                    <table
                      style={{ width: '100%', borderCollapse: 'collapse' }}
                    >
                      <thead>
                        <tr>
                          <th
                            style={{
                              border: '1px solid #ddd',
                              padding: '8px',
                              minWidth: '250px',
                            }}
                          >
                            Address
                          </th>
                          <th
                            style={{ border: '1px solid #ddd', padding: '8px' }}
                          >
                            Landmark
                          </th>
                          <th
                            style={{ border: '1px solid #ddd', padding: '8px' }}
                          >
                            Pincode
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {order.address.map((item, index) => (
                          <tr key={index}>
                            <td
                              style={{
                                border: '1px solid #ddd',
                                padding: '8px',
                              }}
                            >
                              {item.address}
                            </td>
                            <td
                              style={{
                                border: '1px solid #ddd',
                                padding: '8px',
                              }}
                            >
                              {item.landmark}
                            </td>
                            <td
                              style={{
                                border: '1px solid #ddd',
                                padding: '8px',
                              }}
                            >
                              {item.pincode}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </td>
                  <td>
                    <table
                      style={{ width: '100%', borderCollapse: 'collapse' }}
                    >
                      <thead>
                        <tr>
                          <th
                            style={{ border: '1px solid #ddd', padding: '8px' }}
                          >
                            Title
                          </th>
                          <th
                            style={{ border: '1px solid #ddd', padding: '8px' }}
                          >
                            Quantity
                          </th>
                          <th
                            style={{ border: '1px solid #ddd', padding: '8px' }}
                          >
                            Price
                          </th>
                          <th
                            style={{
                              border: '1px solid #ddd',
                              padding: '8px',
                              minWidth: '200px',
                            }}
                          >
                            Description
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {order.items.map((item, index) => (
                          <tr key={index}>
                            <td
                              style={{
                                border: '1px solid #ddd',
                                padding: '8px',
                              }}
                            >
                              {item.title}
                            </td>
                            <td
                              style={{
                                border: '1px solid #ddd',
                                padding: '8px',
                              }}
                            >
                              {item.quantity}
                            </td>
                            <td
                              style={{
                                border: '1px solid #ddd',
                                padding: '8px',
                              }}
                            >
                              {item.price}฿
                            </td>
                            <td
                              style={{
                                border: '1px solid #ddd',
                                padding: '8px',
                              }}
                            >
                              {/* Display the description */}
                              {typeof item.description === 'object' ? (
                                <div>
                                  {Object.entries(item.description).map(
                                    ([key, value]) => (
                                      <div key={key}>
                                        <strong>
                                          {key.charAt(0).toUpperCase() +
                                            key.slice(1)}
                                          :
                                        </strong>{' '}
                                        {value || 'None'}
                                      </div>
                                    )
                                  )}
                                </div>
                              ) : (
                                item.description // Display string description directly
                              )}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </td>
                  <td>{order.totalAmount}฿</td>
                  <td>{order?.orderStatus}</td>
                  <td>
                    <button
                      onClick={() => openModal(order)}
                      style={styles.button}
                    >
                      Update Status
                    </button>
                  </td>
                </tr>
              </>
            ))}
          </tbody>
        </table>
      </div>

      {showModal && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundColor: 'rgba(0,0,0,0.5)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <div
            style={{
              background: 'white',
              padding: '20px',
              justifyContent: 'center',
              borderRadius: '8px',
              minWidth: '320px',
              minHeight: '320px',
              textAlign: 'center',
              display: 'flex',
              flexDirection: 'column',
              gap: '2em',
            }}
          >
            <h3 style={{ margin: 0 }}>Update Order Status</h3>
            <p style={{ margin: 0 }}>Order ID: {selectedOrder?.orderId}</p>
            <div style={{ display: 'flex', flexDirection: 'row', gap: '1rem' }}>
              <button
                onClick={() =>
                  updateOrderStatus(selectedOrder._id, OrderStatus.CANCELLED)
                }
                style={{ ...styles.button, backgroundColor: '#E3232F' }}
              >
                Cancel
              </button>
              <button
                onClick={() =>
                  updateOrderStatus(selectedOrder._id, OrderStatus.DELIVERED)
                }
                style={{ ...styles.button, backgroundColor: '#4CAF50' }}
              >
                Paid & Delivered
              </button>
              <button
                onClick={() =>
                  updateOrderStatus(selectedOrder._id, OrderStatus.PROCESSING)
                }
                style={{ ...styles.button, backgroundColor: '#04A5FB' }}
              >
                Preparing
              </button>
            </div>
            <button onClick={closeModal} style={styles.button}>
              Close
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

const styles = {
  container: {
    padding: '20px',
  },
  buttons: {
    display: 'flex',
    flexDirection: 'row',
    gap: '10px',
    marginBottom: '20px',
  },
  button: {
    padding: '10px 20px',
    backgroundColor: '#001F44',
    minWidth: '97px',
    color: 'white',
    border: 'none',
    borderRadius: '4px',
    cursor: 'pointer',
  },
  table: {
    width: '100%',
    borderCollapse: 'collapse',
  },
  th: {
    padding: '10px',
    border: '1px solid #ddd',
    textAlign: 'left',
    backgroundColor: '#f4f4f4',
  },
  td: {
    alignContent: 'start !important',
    padding: '10px',
    border: '1px solid #ddd',
    textAlign: 'left',
  },
};

export default AdminDashboard;
